import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["detailsModal"];

  connect() {

  }

  openDetailsModal() {
    this.detailsModalTarget.classList.remove("hidden");
  }


}
